import gql from 'graphql-tag'

export const queryComercialBaseList = () => {
	return {
		query: gql`
			{
				comercial_base: conf_comercial_base {
					id
					base
					active
				}
			}
		`,
		update: data =>
			data.comercial_base.map(item => ({
				id: item.id,
				base: item.base,
				edit: true,
				active: item.active
			}))
	}
}
